import React from "react";
import useScreenSizes from "../../hooks/useScreenSizes";
import ProviderPanel from "../../components/Login/ProviderPanel";
import GuestFormPanel from "./GuestFormPanel";
import { MainContainer, VersionFooter } from "../../components/Login/styles";
import FloatLogo from "../../components/general/FloatLogo";

export default function GuestPage() {
  const { isMobile } = useScreenSizes();

  return (
    <MainContainer>
      {!isMobile && <ProviderPanel />}
      <GuestFormPanel />
      <FloatLogo />
      <VersionFooter>v.1.1</VersionFooter>
    </MainContainer>
  );
}
